module.exports = __webpack_public_path__ + "img/Radar-Timeseries.87a2b82e.png";